import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";

type PropsType = {
  items: ItemType[];
};

type ItemType = {
  title: string;
  content: string;
  open: boolean;
};

const FAQCard: React.FC<PropsType> = ({ items }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      {items?.map((item, i) => (
        <div
          className={`${styles.item}`}
          key={i}
          style={{
            boxShadow:
              "0px 4px 16px 0px rgba(0, 0, 0, 0.04), 0px 2px 3px 0px rgba(0, 0, 0, 0.05)",
          }}
          onClick={() => toggleFAQ(i)}
        >
          <div className={styles.itemTitle}>
            <div className="w-[95%]">{item.title}</div>
            {openIndex === i ? <ChevronUp /> : <ChevronDown />}
          </div>
          <div
            className={`${styles.itemContent} w-[95%]" ${
              openIndex === i ? styles.itemContentOpen : ""
            }`}
          >
            {item.content}
          </div>
        </div>
      ))}
    </div>
  );
};

const styles = {
  item: "mb-[16px] last:mb-0  p-[16px] rounded-[8px] cursor-pointer bg-white",
  itemTitle: `text-[18px] leading-[24px] font-normal flex items-center justify-between`,
  arrow: "block rotate-90",
  arrowOpen: "-rotate-90 transition-all",
  itemContent:
    "text-[16px] text-[#727272] max-h-0 overflow-hidden block transition-all",
  itemContentOpen: "max-h-[9999px] pt-[15px]",
};

export default FAQCard;
